<script setup>
    import { ref, onMounted, getCurrentInstance, provide, nextTick, watch } from "vue";
    import { useAlertStore } from "../stores/alertStore";
    import DefaultLayout from '../layouts/DefaultLayout.vue'
    import systemService from '../services/system/systemCodeService'
    import AlertModal from "../components/ui-components/modal/AlertModal.vue";
    import MatchingCorporationUpdateModal from "./user/components/modal/matching/MatchingCorporationUpdateModal.vue";
    import MatchingUserUpdateModal from "./user/components/modal/matching/MatchingUserUpdateModal.vue";
    import UserGbHistoryApproveModal from "./user/components/modal/userGb/UserGbHistoryApproveModal.vue";
    import UserGbHistoryRejectModal from "./user/components/modal/userGb/UserGbHistoryRejectModal.vue";
    import JobFairUserApproveModal from "@/pages/user/components/modal/jobFair/JobFairUserApproveModal.vue";
    import JobFairCorpApproveModal from "@/pages/user/components/modal/jobFair/JobFairCorpApproveModal.vue";
    import NoticeModal from "@/pages/user/components/modal/NoticeModal.vue";
    import _ from "lodash";
    import {useDeviceStore} from "@/stores/device";
    import {useRoute} from "vue-router";

    const globals = getCurrentInstance().appContext.config.globalProperties;
    globals.$gb = {};

    const route = useRoute()

    const isGbLoaded = ref(false);

    const deviceStore = useDeviceStore();

    // 기업 채용 모달 상태를 리액티브 변수로 정의
    const showMatchingCorporationUpdateModal = ref(false);

    // 구직자 채용 모달 상태를 리액티브 변수로 정의
    const showMatchingUserUpdateModal = ref(false);

    // 회원 유형 변경 안내(승인) 모달
    const userGbHistoryApproveModal = ref(null)

    // 회원 유형 변경 안내(거절) 모달
    const userGbHistoryRejectModal = ref(null)

    // 특별채용관 참가 확정 모달 - 구직자
    const showJobFairUserApproveModal = ref(false);
    const jobFairUserApproveModal = ref([]);
    // 특별채용관 참가 확정 모달 - 기업
    const showJobFairCorpApproveModal = ref(false);
    const jobFairCorpApproveModal = ref([]);
    const modalList = ref([]);

    // 공지사항 모달
    const noticeModal = ref(null);

    const alertModal = ref(null)
    const confirmModal = ref(null)
    const alertStore = useAlertStore()

    // ref가 실제로 바인딩되는 시점에 등록을 보장
    watch(alertModal, (val) => {
        if (val) alertStore.register(val)
    }, { immediate: true })
    watch(confirmModal, (val) => {
        if (val) alertStore.registerConfirmModal(val)
    }, { immediate: true })

    onMounted(async () => {
        await nextTick();
        // nextTick 이후에도 혹시 null이면, watch에서 즉시 처리됨
        if (alertModal.value) alertStore.register(alertModal.value)
        if (confirmModal.value) alertStore.registerConfirmModal(confirmModal.value)
    })

    // 기업 로그인 성공시, 기업 모달 표시
    const handleCorpLoginSuccess = () => {
      const currentURL = window.location.href;
      // 채용 제안 현황이 아닐 경우, true
      const isPropURL = !currentURL.includes("/mypage/proposal");
      // 입사 지원 현황이 아닐 경우, true
      const isResURL = !currentURL.includes("/mypage/userResume");
      // 오프라인 강의 수강신청하기가 아닐 경우, true
      const isOfflineURL = !currentURL.includes("/lecture/offline/detail/");
      // 온라인 강의 수강신청하기가 아닐 경우, true
      const isOnlineURL = !currentURL.includes("/lecture/online/detail/");


      if(isPropURL && isResURL) {
        if(!deviceStore.isMobile) {
          showMatchingCorporationUpdateModal.value = true;
        }
      } else if(isOfflineURL && isOnlineURL) {
        showMatchingCorporationUpdateModal.value = true;
      }
    };
    provide('onCorpLoginSuccess', handleCorpLoginSuccess)

    // 구직자 로그인 성공시, 구직자 모달 표시
    const handleUserLoginSuccess = () => {
      const currentURL = window.location.href;
      // 채용 제안 현황이 아닐 경우, true
      const isPropURL = !currentURL.includes("/mypage/proposal");
      // 입사 지원 현황이 아닐 경우, true
      const isResURL = !currentURL.includes("/mypage/userResume");
      // 오프라인 강의 수강신청하기가 아닐 경우, true
      const isOfflineURL = !currentURL.includes("/lecture/offline/detail/");
      // 온라인 강의 수강신청하기가 아닐 경우, true
      const isOnlineURL = !currentURL.includes("/lecture/online/detail/");
      if(isPropURL && isResURL) {
        if(!deviceStore.isMobile) {
          showMatchingUserUpdateModal.value = true;
        }
      } else if(isOfflineURL && isOnlineURL) {
        showMatchingUserUpdateModal.value = true;
      }
    };
    provide('onUserLoginSuccess', handleUserLoginSuccess)

    // 사용자 회원 유형 변경 "승인" 모달을 띄워야 하는 경우, 모달 표시
    const handleUserGbHistoryApproveModal = async (seq, beforeUserGb, afterUserGb) => {
      userGbHistoryApproveModal.value.init(seq, beforeUserGb, afterUserGb);
      await userGbHistoryApproveModal.value.show();
    }
    provide('onUserGbHistoryApproveModal', handleUserGbHistoryApproveModal)

    // 사용자 회원 유형 변경 "거절" 모달을 띄워야 하는 경우, 모달 표시
    const handleUserGbHistoryRejectModal = async (seq, beforeUserGb, afterUserGb) => {
      userGbHistoryRejectModal.value.init(seq, beforeUserGb, afterUserGb);
      await userGbHistoryRejectModal.value.show();
    }
    provide('onUserGbHistoryRejectModal', handleUserGbHistoryRejectModal)

    // 특별채용관 참가 확정 모달 - 구작자
    const handleJobFairUserApproveModal = (list) => {
      modalList.value = list;
      if(!deviceStore.isMobile) {
        showJobFairUserApproveModal.value = true;

        setTimeout(() => {
          list.forEach((item, i) => {
            jobFairUserApproveModal.value[i].init(item.ojfId);
            jobFairUserApproveModal.value[i].show();
          });
        }, 100)
      }
    }
    provide('onJobFairUserApproveModal', handleJobFairUserApproveModal)

    // 특별채용관 참가 확정 모달 - 기업
    const handleJobFairCorpApproveModal = (list) => {
      modalList.value = list;

      if(!deviceStore.isMobile) {
        showJobFairCorpApproveModal.value = true;

        setTimeout( () => {
          list.forEach((item, i) => {
            jobFairCorpApproveModal.value[i].init(item.ojfId, item.recruitmentHallSeq);
            jobFairCorpApproveModal.value[i].show();
          });
        }, 100)
        }
    }
    provide('onJobFairCorpApproveModal', handleJobFairCorpApproveModal)

    // 공지사항 팝업
    const handleNoticeModal = async () => {
      // await nextTick();
      // const currentPath = window.location.pathname;
      // // 홈 화면이고 admin 경로가 아닐 때만
      // if (noticeModal.value && currentPath === '/' && !currentPath.includes('/admin')) {
      //   await noticeModal.value.init();
      //   await noticeModal.value.show();
      // }
    }
    provide('onNoticeModal', handleNoticeModal)

    // 홈 화면(메인) 진입 시에만 공지사항 모달 띄우기
    onMounted(async () => {
        await nextTick();
        const currentPath = window.location.pathname;
        if (currentPath === '/' && !currentPath.includes('/admin')) {
          handleNoticeModal();
        }
    });

    watch(
      () => route.path,
      async (newPath, oldPath) => {
        // 경로가 다른 곳에서 '/'로 변경된 경우에만, admin 경로는 제외
        if (oldPath !== '/' && newPath === '/' && !newPath.includes('/admin')) {
          await nextTick();
          handleNoticeModal();
        }
      }
    );
    const components = {
      MatchingCorporationUpdateModal,
      MatchingUserUpdateModal,
      UserGbHistoryApproveModal,
      UserGbHistoryRejectModal,
      JobFairUserApproveModal,
      JobFairCorpApproveModal,
    };

    // 로그 아웃시, 채용 모달 초기화
    const handleLogoutModal = () => {
      showMatchingCorporationUpdateModal.value = false;
      showMatchingUserUpdateModal.value = false;

      showJobFairUserApproveModal.value = false;
      showJobFairCorpApproveModal.value = false;
    }
    provide('onLogoutModal', handleLogoutModal)


    const CODE_NAMES = [
        "USER_GB",
        "SEX",
        "EMPLOYEE_NUM_GB",
        "INDUSTRY_GB",
        "EDU_HIST_GB",
        "EDU_TENURE_GB",
        "POFOL_GB",
        "DEGREE_GB",
        "LANG_LEVEL_GB",
        "DISABLE_GRADE_GB",
        "MIL_SERVICE_GB",
        "MAJOR_GB",
        "FULL_SCORE_GB",
        "SCHOOL_GB",
        "LANG_GB",
        "SUBMAJOR_TYPE_GB",
        "BOARD_GB",
        "BOARD_GROUP_FAQ",
        "BOARD_GROUP_QNA",
        "MENU_AREA_GB",
        "BIZ_STATE_GB",
        "TAX_TYPE_GB",
        "LECT_GB",
        "REG_TERM_GB",
        "LECT_TERM_GB",
        "FIN_CRITERIA_GB",
        "TICKET_OFFER_GB",
        "INTV_TERM_GB",
        "BANNER_GB",
        "MSG_GB",
        "TEMPATE_TYPE_EMAIL",
        "TEMPATE_TYPE_SMS",
        "SURVEY_Q_GB",
        "SURVEY_Q_TYPE",
        "MATCHING_JOB_STATE_CORP_GB",
        "MATCHING_JOB_STATE_USER_GB",
        "MATCHING_JOB_STATE_CORP_GB2",
        "MATCHING_JOB_STATE_USER_GB2",
        "USER_GB_STATE_GB",
        "EVAL_STATE_GB1",
        "EVAL_STATE_GB2",
        "LECT_STATE_GB1",
        "LECT_STATE_GB2",
        "OJF_STATE_GB",
        "USER_JOIN_STATE_GB",
        "ADMIN_JOIN_STATE_GB",
        "APPLY_STATE_GB",
        "USER_INTV_PROP_STATE_GB",
        "ADMIN_INTV_PROP_STATE_GB",
        "INTV_GB",
        "SALARY_GB",
        "CORP_GB",
        "SALES_AMT_GB",
        "CORP_PUBLIC_GB",
    ];

    onMounted(()=>{
        const systemCodesInStorage = sessionStorage.getItem('systemCodeValues');
        if(systemCodesInStorage) {
            const result = JSON.parse(systemCodesInStorage);
            _.each(result, async codeObj => {
              const {codeValues} = codeObj;
              const temp = await _.map(codeValues, codeVal => {
                return {label: codeVal.codeValueName, value: codeVal.codeValue};
              }) || [];

              switch (codeObj.codeName) {
                case 'MAJOR_GB':
                  temp.unshift({label: '전공 계열 선택', value: '',});
                  break;
                case 'SCHOOL_GB':
                  temp.unshift({label: '학력 선택', value: '',});
                  break;
                case 'LANG_GB':
                  temp.unshift({label: '언어 선택', value: '',});
                  break;
                case 'EDU_TENURE_GB':
                  temp.unshift({label: '상태 선택', value: '',});
                  break;
                case 'EDU_HIST_GB':
                  temp.unshift({label: '학력 선택', value: '',});
                  break;
                default:
                  break;
              }
              globals.$gb[codeObj.codeName] = temp;
            });
            isGbLoaded.value = true;
        } else {
            getSystemCodeValues();
        }
    });

    const getSystemCodeValues = async () => {
      await systemService.getSystemCodeValues(CODE_NAMES)
        .then( (res) => {
            // console.log(res);
            const result = res.data.result;
            if(res.data.code.toLowerCase() === 'success') {
              // console.log(result);
              _.each(result, async codeObj => {
                const {codeValues} = codeObj;
                const temp = await _.map(codeValues, codeVal => {
                  return {label: codeVal.codeValueName, value: codeVal.codeValue};
                }) || [];

                switch (codeObj.codeName) {
                  case 'MAJOR_GB':
                    temp.unshift({label: '전공 계열 선택', value: '',});
                    break;
                  case 'SCHOOL_GB':
                    temp.unshift({label: '학력 선택', value: '',});
                    break;
                  case 'LANG_GB':
                    temp.unshift({label: '언어 선택', value: '',});
                    break;
                  case 'EDU_TENURE_GB':
                    temp.unshift({label: '상태 선택', value: '',});
                    break;
                  case 'EDU_HIST_GB':
                    temp.unshift({label: '학력 선택', value: '',});
                    break;
                  default:
                    break;
                }
                globals.$gb[codeObj.codeName] = temp;
              });
            }

            if(result && result.length > 0) {
              sessionStorage.setItem('systemCodeValues', JSON.stringify(result));
            }
        })
        .catch( (error) => {
            console.log(error);
        });
      isGbLoaded.value = true;
    }

</script>

<template>
    <DefaultLayout v-if="isGbLoaded">
        <RouterView/>
    </DefaultLayout>
    <AlertModal ref="alertModal" :content="alertStore.content" />
    <ConfirmModal ref="confirmModal" :content="alertStore.content" />
    <MatchingCorporationUpdateModal v-if="showMatchingCorporationUpdateModal" />
    <MatchingUserUpdateModal v-if="showMatchingUserUpdateModal" />
    <UserGbHistoryApproveModal ref="userGbHistoryApproveModal"/>
    <UserGbHistoryRejectModal ref="userGbHistoryRejectModal"/>
    <JobFairUserApproveModal v-if="showJobFairUserApproveModal" v-for="(item, index) in modalList" :key="index" ref="jobFairUserApproveModal" />
    <JobFairCorpApproveModal v-if="showJobFairCorpApproveModal" v-for="(item, index) in modalList" :key="index" ref="jobFairCorpApproveModal" />
    <NoticeModal ref="noticeModal" />
</template>
